module.exports = __webpack_public_path__ + "img/graphics.c9080db6.webp";